export default {
  items: [
    {
      name: 'Banners Destaque',
      url: '/banners-wrapper',
      icon: 'icon-picture',
      children: [{
        name: 'Home',
        url: {
          name: 'manageables.index',
          params: { entity: 'general-banners' }
        }
      },
      {
        name: 'Alunos',
        url: {
          name: 'manageables.index',
          params: { entity: 'general-banners-student' }
        }
      },
      {
        name: 'ENEM',
        url: {
          name: 'manageables.index',
          params: { entity: 'general-banners-enem' }
        }
      }]
    },
    {
      name: 'Banners Secundários',
      url: {
        name: 'manageables.index',
        params: { entity: 'general-other-banners' }
      },
      icon: 'icon-briefcase'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/navbar/marketing.js